import type { ModalSteps } from "@/features/card/components/OnboardingModal";
import {
  CardWelcomeSlideContent,
  CardActivationSuccessSlideContent,
  YeatiesConsentCheckbox,
} from "@/features/card/components/OnboardingModal/OnBoardingModalElements/OnboardingModalSteps";
import type { YeatiesConsentState } from "@/features/purchasePoints";

type OnboardingModalContentProps = {
  modalStep: ModalSteps
  yeaties: YeatiesConsentState
  isYeatiesChecked: boolean
  onYeatiesCheckedChange: (isChecked: boolean) => void
};

export const OnboardingModalContent = ({
  modalStep,
  yeaties,
  isYeatiesChecked,
  onYeatiesCheckedChange,
}: OnboardingModalContentProps) => {
  // The box before the hint: left unticked it records a refusal, so it must not fall below the fold.
  const renderNewCardState = () => (
    <>
      {yeaties.isOffered && (
        <div className="-mt-8 mb-6 flex w-full justify-center animate-slide-up-delayed">
          <YeatiesConsentCheckbox isChecked={isYeatiesChecked} onChange={onYeatiesCheckedChange} />
        </div>
      )}
      <CardWelcomeSlideContent />
    </>
  );

  const renderCardActivationState = () => null;

  const renderCardSuccessState = () => <CardActivationSuccessSlideContent consent={yeaties.consent} />;

  const slides = {
    "new-card": renderNewCardState,
    "card-activation": renderCardActivationState,
    "card-success": renderCardSuccessState,
  };

  return slides[modalStep]();
};
